import { Trophy } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";
import { ServiceSection } from "@/types/sections";

const credentialsSection: ServiceSection = {
  type: SECTION_TYPES.CREDENTIALS,
  content: {
    header: "Our Credentials",
    subheader: "We're a team of professionals who are passionate about what we do.",
    images: [
      {
        alt: "",
        providerId: "",
        source: "",
        url: "https://ik.imagekit.io/4wu305uo4/Badges/licensed-1.webp?updatedAt=1744136963931",
      },
      {
        alt: "",
        providerId: "",
        source: "",
        url: "https://ik.imagekit.io/4wu305uo4/Badges/j6mfb3-soap_103i036000000000000028.png?updatedAt=1741967789759",
      },
      {
        alt: "",
        providerId: "",
        source: "",
        url: "https://ik.imagekit.io/4wu305uo4/Badges/1677446233googlereviewsjpg.jpeg?updatedAt=1741191632095",
      },
      {
        alt: "",
        providerId: "",
        source: "",
        url: "https://ik.imagekit.io/4wu305uo4/Badges/rs=w_600,cg_true.webp?updatedAt=1741783582981",
      },
    ],
  },
  meta: {
    displayName: "Credentials",
    displayDescription: "Showcase all your credentials (awards, certifications, etc.)",
    displayIcon: Trophy,
    variantsCount: 2,
  },
};

export default credentialsSection;
